<template>
  <div>
    <h3 class="text-lg font-bold text-[#ff9b05] mb-2">Equipamentos do Artigo</h3>
    <div v-if="equipamentos.length > 0">
      <AppTable
        :visibility="true"
        :show="true"
        :table_data="equipamentos"
        :columns="columnsEquipamentos"
        table_title="Lista de Equipamentos"
      />
    </div>
    <div v-else>
      <p class="text-white">Nenhum equipamento encontrado para este artigo.</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import AppTable from '@/components/tables/table.vue';

export default {
  name: 'EquipamentosDoArtigo',
  components: {
    AppTable,
  },
  props: {
    artigoId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_URL_BASE,
      equipamentos: [],
      columnsEquipamentos: [
        { label: 'ID', field: 'id' },
        { label: 'Nome', field: 'nome' },
        { label: 'Descrição', field: 'descricao' },
        { label: 'Código', field: 'codigo' },
        { label: 'Status', field: 'status' },
      ],
    };
  },
  methods: {
    async fetchEquipamentos() {
      try {
        const response = await axios.get(`${this.baseURL}/api/v1/artigo/${this.artigoId}/equipamentos/`);
        if (response.status === 200) {
          this.equipamentos = response.data.equipamentos;
        } else {
          this.equipamentos = [];
        }
      } catch (error) {
        console.error('Erro ao buscar equipamentos:', error);
        this.equipamentos = [];
      }
    },
  },
  created() {
    this.fetchEquipamentos();
  },
};
</script>

<style scoped>
/* Seu estilo aqui */
</style>
